export const defaultComparisonMap = {
  text: {
    op: '<>',
    value: ''
  },
  number: {
    op: '=',
    value: null
  },
  date: {
    op: '=',
    value: null
  },
  yes_no: {
    op: '=',
    value: null
  },
  exact: {
    op: '=',
    value: null
  },
  dropdown: {
    op: '=',
    value: null
  },
  multiple_choice: {
    op: 'ILIKE',
    value: null
  },
  confirmation: {
    op: '=',
    value: 'true'
  }
};

export const negatedDefaultComparisonMap = {
  exact: {
    op: '<>',
    value: null,
    negated: true
  },
  multiple_choice: {
    op: 'NOT ILIKE',
    value: null,
    negated: true
  }
};
